import Blocks from "editorjs-blocks-react-renderer/dist";
import { Link } from "gatsby";
import React from "react";
import ImageRenderer from "../imageRenderer";

const EventsGroup = ({ data }) => {
  if (!data || !data.EventTeasers) {
    return <></>; // Return empty fragment if data is missing
  }

  return (
    <div>
      <div className="max-w-screen-xl xxl:max-w-screen-3xl mx-auto my-18 xl:p-0 p-5 ">
        <div className="my-10 text-center">
          <div className="text-teal text-2xl font-bold">
            {data.EventsTeaserTitle || ""}
          </div>
          <p className="text-sm">{data.EventsTeaserIntroText || ""}</p>
        </div>
        <div className="flex justify-between items-center mb-8">
          <div className="w-full">
            <h3 className="text-base font-medium mb-5 text-orange">Date</h3>
          </div>
          <div className="w-full">
            <h3 className="text-base font-medium mb-5 text-orange">
              Event Title
            </h3>
          </div>
          <div className="w-full">
            <h3 className="text-base font-medium mb-5 text-orange lg:block hidden">
              Description
            </h3>
          </div>
        </div>

        {data.EventTeasers.length > 0 &&
          data.EventTeasers.map((item, index) => {
            const teaser = item.events_teaser || {};
            return (
              <div
                key={index}
                className="flex justify-between py-6 border-b border-b-[#e5e7eb]"
              >
                <div className="w-full">
                  <div className="text-lg lg:flex items-center lg:justify-start justify-center">
                    <p>{teaser.EventTeaserStartDate || "N/A"}</p>
                    <p className="lg:mx-2">|</p>
                    <p>{teaser.EventTeaserEndDate || "N/A"}</p>
                  </div>
                </div>
                <div className="w-full">
                  <div className="text-lg">{teaser.EventTeaserTitle || ""}</div>
                </div>
                <div className="prose prose-p:m-0 prose-a:text-sm prose-a:no-underline w-full flex items-center justify-between">
                  <div className="lg:block hidden max-w-[270px]">
                    {teaser.EventTeaserSummary?.data?.EventTeaserSummary ? (
                      <Blocks
                        data={JSON.parse(
                          teaser.EventTeaserSummary.data.EventTeaserSummary
                        )}
                        renderers={{
                          image: ImageRenderer,
                        }}
                      />
                    ) : (
                      <span></span> // Empty span to avoid layout shifts
                    )}
                  </div>
                  <div className="ml-5">
                    {teaser.events_article?.slug ? (
                      <Link
                        to={`/events/${teaser.events_article.slug}`}
                        className="bg-orange rounded-lg px-5 py-2 font-display font-bold text-base text-white no-underline hover:text-black border-2 border-orange hover:bg-white transition duration-500"
                      >
                        Explore
                      </Link>
                    ) : (
                      <span></span> // Empty span to prevent layout break
                    )}
                  </div>
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default EventsGroup;
